import { useContext } from 'react';

import { ProfileUserContext } from '../../contexts/profileUser';
import { commonContextLayerData } from './client-event-tracking';

export function useProfileUserLayer() {
  const profileUser = useContext(ProfileUserContext);
  return commonContextLayerData({context_page_type: 'user', context_page_id: profileUser.uuid});
}

